import CustomizeTable from "./CustomizeTable";

export default CustomizeTable;
